import { render } from "./RegisterVerifyView.vue?vue&type=template&id=db0ce7e4&scoped=true&ts=true"
import script from "./RegisterVerifyView.vue?vue&type=script&lang=ts"
export * from "./RegisterVerifyView.vue?vue&type=script&lang=ts"

import "./RegisterVerifyView.scss?vue&type=style&index=0&id=db0ce7e4&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0ce7e4"]])

export default __exports__